import { Dirary } from "../../types/dirary";

export const useCheckSendable = () => {
  const invalidSiteNames = [
    "製番を入力してください",
    "工程データが見つかりません",
    "受注データが見つかりません",
    "原価確定済です",
  ];

  //全体の入力をチェック
  const checkDiaryListSendable = (
    totalTime: { hour: number; min: number; text: string },
    diaryList: Dirary[],
    deleteDiaryList: Dirary[]
  ): number => {
    if (diaryList.length === 0) {
      if (deleteDiaryList.length > 0) return 0;
      return -1;
    }

    const isValidDiary = diaryList.every((diary) => diary.isSendable);
    const isValidTotalTimeMin =
      totalTime.min ===
        diaryList.reduce((acc, diary) => acc + diary.workingTimeByMinute, 0) &&
      totalTime.min === diaryList[0].totalWorkingTimeByMinute;
    const isValidTotalTimeHour =
      totalTime.hour ===
        diaryList.reduce((acc, diary) => acc + diary.workingTimeByHour, 0) &&
      totalTime.hour === diaryList[0].totalWorkingTimeByHour;
    console.log(
      "DEBUG_DAILYLIST_CHANGE",
      totalTime.hour,
      diaryList[0].totalWorkingTimeByHour,
      diaryList.reduce((acc, diary) => acc + diary.workingTimeByHour, 0),
      totalTime.min,
      diaryList[0].totalWorkingTimeByMinute,
      diaryList.reduce((acc, diary) => acc + diary.workingTimeByMinute, 0),
      isValidDiary,
      isValidTotalTimeMin,
      isValidTotalTimeHour
    );
    if (!isValidDiary) return 1; //日報が不正な場合
    if (!isValidTotalTimeMin) return 2; //作業時間が不正な場合
    if (!isValidTotalTimeHour) return 3; //作業時間が不正な場合
    return 0;
  };
  //個別の作業日報の入力をチェック
  const checkDiarySendable = (diary: Dirary) => {
    const isValidProductNo = /^\d{8}$/.test(diary.productNo);
    const isValidProductBno = /^\d{2}$/.test(diary.productBno);
    const isValidSiteName =
      diary.siteName.trim() !== "" &&
      !invalidSiteNames.includes(diary.siteName);
    const isValidProcess =
      diary.processId !== "0000" &&
      diary.processName !== "未設定" &&
      diary.slipNumber !== "0000000" &&
      diary.processId !== "" &&
      diary.processName !== "" &&
      diary.slipNumber !== "";
    if (!isValidProductNo) return 1;
    if (!isValidProductBno) return 2;
    if (!isValidSiteName) return 3;
    if (!isValidProcess) return 4;
    return 0;
  };
  return { checkDiaryListSendable, checkDiarySendable };
};
